import { z } from 'zod';

import type { FleetGroup } from '#domain/FleetGroup.ts';
import { apiTagsRoot } from '#store/apiTagsRoot.ts';

import { mapTagsToFleetGroups } from './adapters/tagsAdapter.ts';
import { validateWarn } from './validateZodHelper.ts';

const TAG = 'TAGS';

const tagSchema = z
    .object({
        id: z.string(),
        type: z.string(),
        name: z.string(),
        account_id: z.string(),
    })
    .passthrough();

const linkSchema = z.object({ href: z.string() }).passthrough();

const tagListSchema = z
    .object({
        items: z.array(tagSchema).default([]),
        _links: z
            .object({
                self: linkSchema,
                next: linkSchema.optional(),
            })
            .optional(),
    })
    .passthrough();

export type ApiTag = z.infer<typeof tagSchema>;

export const tagsApiSlice = apiTagsRoot.injectEndpoints({
    endpoints: build => ({
        getFleetGroups: build.query<FleetGroup[], void>({
            query: () => ({
                url: '/tags',
                method: 'GET',
                params: { type: 'user', limit: 2000 },
            }),
            providesTags: [TAG],
            transformResponse: (response, meta, arg) =>
                mapTagsToFleetGroups(validateWarn(tagListSchema)(response, meta, arg).items),
        }),
    }),
});

export const { useGetFleetGroupsQuery } = tagsApiSlice;
